import { Navigate, useLocation } from "react-router-dom";

import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";

const VerifiedSignInRoute = ({ children }: { children: JSX.Element }) => {
    const { isAuthenticated } = FirebaseAuthContainer.useContainer();
    const location = useLocation();

    return !isAuthenticated() ? children : <Navigate to={location.state?.from || "/"} />;
};

export default VerifiedSignInRoute;
